export default __webpack_public_path__ + "static/media/dtt.4001f1fc.jpg";